import api from './api';
import { ApiResponse } from '../types';

export interface Branding {
  brandName: string;
  brandSubtitle: string;
  brandLogoUrl: string | null;
  brandColor: string | null;
}

/** 后端返回的原始品牌(任意字段可空)。 */
export interface RawBranding {
  brandName: string | null;
  brandSubtitle: string | null;
  brandLogoUrl: string | null;
  brandColor: string | null;
}

/** 中性默认品牌 —— 机构未设置 / 登录前未知机构时使用。 */
export const DEFAULT_BRANDING: Branding = {
  brandName: '问卷测评系统',
  brandSubtitle: 'Questionnaire Assessment Platform',
  brandLogoUrl: null,
  brandColor: null,
};

/** 逐字段 null 回退默认。 */
export function resolveBranding(raw: RawBranding | null): Branding {
  if (!raw) return { ...DEFAULT_BRANDING };
  return {
    brandName: raw.brandName?.trim() || DEFAULT_BRANDING.brandName,
    brandSubtitle: raw.brandSubtitle?.trim() || DEFAULT_BRANDING.brandSubtitle,
    brandLogoUrl: raw.brandLogoUrl?.trim() || null,
    brandColor: raw.brandColor?.trim() || null,
  };
}

export async function fetchCurrentBranding(): Promise<Branding> {
  try {
    // 置于 /admin 下,以匹配生产 nginx 的 /api/admin/ → admin upstream 代理。
    const resp = await api.get<ApiResponse<RawBranding>>('/admin/branding/current');
    return resolveBranding(resp.data.data);
  } catch {
    return { ...DEFAULT_BRANDING }; // 失败回退,绝不阻塞界面
  }
}
